import { Heading, Text } from "@/design-system";
import { PageSection } from "@/pages/landingPage/components/pageSection";
import type { SourcedFact } from "../types";
import { SourcedMetricGrid } from "./sourcedMetricGrid";

type CaseHighlightProps = {
  id: string;
  title: string;
  text: string;
  metrics: SourcedFact[];
};

export const CaseHighlight = ({
  id,
  title,
  text,
  metrics,
}: CaseHighlightProps) => (
  <PageSection labelledBy={`${id}-title`}>
    <div className="bg-ds-surface-sunken rounded-ds-xl flex flex-col gap-6 p-6 sm:p-10">
      <Heading level={2} id={`${id}-title`}>
        {title}
      </Heading>
      <Text size="lead" tone="muted" className="max-w-3xl">
        {text}
      </Text>
      <SourcedMetricGrid facts={metrics} className="lg:grid-cols-2" />
    </div>
  </PageSection>
);
